module.exports = __webpack_public_path__ + "img/moneys.531b6502.svg";